import { isNullOrUndefined, setChatWidgetOpen } from '@beef/utils';
import { SupportInfoItemType } from "../utils";
export var useButtonConfig = function useButtonConfig(_ref) {
  var changePopup = _ref.changePopup,
    href = _ref.href,
    onClose = _ref.onClose,
    type = _ref.type;
  var isPhone = type === SupportInfoItemType.phone;
  var isChat = type === SupportInfoItemType.chat;
  var onClick = function onClick() {
    if (isPhone) {
      changePopup();
    }
    if (isChat && isNullOrUndefined(href)) {
      setChatWidgetOpen(true);
      onClose();
    }
  };
  var buttonConfig = {
    id: 'id',
    onClick: onClick
  };
  var linkConfig = !isPhone || isChat && isNullOrUndefined(href) ? {
    href: href,
    id: 'helpFTTB'
  } : undefined;
  return {
    buttonConfig: buttonConfig,
    linkConfig: linkConfig
  };
};